import { callExternalApi } from "./external-api.service";

const tlogApiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;

export const getScoreBreakdownResource = async (clubId) => {
    const config = {
        url: `${tlogApiServerUrl}/api/score-breakdowns`,
        method: "POST",
        data: { clubId },
        headers: {
            "content-type": "application/json",
          },
      };
  
    return await callExternalApi({config});
};